import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// CRITICAL CACHE BUSTING v3.0.1 - 2025-09-06 15:31
// お知らせシステムエラー完全解決 - announcementManager削除済み
// 新しいビルドハッシュ強制生成 - ブラウザキャッシュクリア対応
